module.exports = __webpack_public_path__ + "static/img/049_TO8_1574.6c09ab7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/049_TO8_1574.jpg
// module id = GJ1s
// module chunks = 0